import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts'
import './styles/app.css'
import { AppProviders } from './app/providers'
import { queryClient } from './app/query-client'
import { router } from './app/router'
import { installSessionExpiryHandler } from './app/session-expiry'
import { startAppearanceSync } from './lib/appearance'
import { initI18n } from './lib/i18n'
import { startThemeSync } from './lib/theme'
import { startTypography } from './lib/typography'

initI18n()
startThemeSync()
startAppearanceSync()
startTypography()
installSessionExpiryHandler(router, queryClient)

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
